<template>
    <div name="document" @click="goTo(`/account/loans/${loan.id}/documents/${document.name}`)"
        class="flex items-center py-4 px-6 rounded-lg my-7 button"
        :class="[{'cursor-pointer': document.status !== 'completed'}, getBackgroundColorClass]">
        <div class="flex-auto pr-6 text-white">
            <p class="font-semibold leading-snug">Sign Loan Agreement to Secure Your Deposit <i class="fa-solid fa-arrow-up-right-from-square inline-block pl-2"></i></p>

        </div>
        <div class="flex-initial text-2xl">
            <i v-if="document.status === 'completed'" class="fas fa-check-circle text-green-500" />
            <i v-else-if="document.status === 'signed'" class="fas fa-circle-notch text-green-500 fa-spin" />
            <i v-else class="far fa-circle" />
        </div>
    </div>
</template>

<script>
    import { analytics } from '../../../analytics';

    export default {
        props: ['document', 'loan'],

        data() {
            return {
                theme: window.theme || 'aurora'
            };
        },

        methods: {
            goTo(url) {

                analytics.docusignEvents.signLoanAgreement({
                    loan_id: this.loan.id,
                    loan_status: this.loan.status,
                    user_id: this.loan.user_id,
                    document_id: this.document.id,
                    document_name: this.document.name,
                    document_label: this.document.label,
                    document_status: this.document.status,
                    page_name: 'SIGN_LOAN_DOCUMENTS',
                });

                window.location = url;
            }
        },

        computed: {
            getBackgroundColorClass() {
                return this.theme === 'phoenix' ? 'shadow-action bg-action' : 'bg-primary-700';
            },
        }
    }
</script>
